/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { REGISTRATION_STEPS } from 'constants/auth'
import CreateProfileProgress from 'apps/Profile/CreateProfileProgress'
import SignUpForms from './apps/SignUpForms'
import Terms from './apps/Terms'
import Congrats from './apps/Congrats'

interface IProps {
  step: REGISTRATION_STEPS,
}

const CreateProfile: React.FC<IProps> = ({
  step,
}) => (
  <div>
    <div className='row no-gutters'>
      <CreateProfileProgress step={step} />
    </div>
    {step === REGISTRATION_STEPS.payment && <SignUpForms/>}
    {step === REGISTRATION_STEPS.terms && <Terms />}
    {step === REGISTRATION_STEPS.congrats && <Congrats/>}
  </div>
)

export default CreateProfile
